import React from 'react'

const ManageServers = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="glass p-12 sm:p-16 text-center max-w-lg w-full relative overflow-hidden">
        <div className="absolute -top-24 -left-24 w-56 h-56 rounded-full glow-violet blur-2xl" />
        <p className="font-Bebas text-xl text-reored tracking-[0.3em] mb-3">COMING SOON</p>
        <h1 className="font-Bebas text-4xl sm:text-5xl text-white mb-4 tracking-wide">
          SERVER DASHBOARD
        </h1>
        <p className="font-poppins text-white/50 text-sm sm:text-base">
          Manage welcome messages, auto-roles and more — right from the web.
          We're building it now.
        </p>
      </div>
    </div>
  )
}

export default ManageServers
